// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports

import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {getDataPointExpressionByDataPointId} from "../DataPointClient";
import {changeDataPoint} from "../dataPointSlice";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {Avatar, Stack, Tooltip} from "@mui/material";
import {deepOrange} from "@mui/material/colors";
import Typography from "@mui/material/Typography";


// Main Function
export default function DataPointExpressionListDrawer({fetchdataPointExpressions}) {


    // ****************** BEGIN STATES ****************************

    const [dataPointExpressions, setdataPointExpressions] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const dispatchDrawerCrudSnackbarSlc = useDispatch() ;
    const dispatchDrawerdataPointExpression = useDispatch() ;
    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.expressionListId);
    const selectorExpressionDrawerState = useSelector((state) => state.dataPointSlc.value.expressionListDrawerState);
    const displayId = useSelector((state) => state.dataPointSlc.value.id);
    const displayName = useSelector((state) => state.dataPointSlc.value.name);

    // ********************** END STORE ********************************


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const dispatchData = useDispatch();

    // ****************** BEGIN FETCH ****************************

    const fetchDataPointExpressionList = () =>
        getDataPointExpressionByDataPointId(selectorDataPointId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setdataPointExpressions(data);
            });


    useEffect(() => {
        fetchDataPointExpressionList();
    }, [ useSelector((state) => state.dataPointSlc.value.expressionListDrawerState)===true]);

    // ****************** END FETCH ****************************


    const renderdataPointExpressions = dataPointExpressions => {
        if (dataPointExpressions.length <= 0) {
            return "No Data";
        }}


    // ****************** BEGIN CRUD ***********************************

    // ****************** END CRUD ***********************************

    function closeExpressionListDrawer() {
        dispatchData(changeDataPoint({expressionListId: 0, expressionListDrawerState: false}));
    };


    // ****************** BEGIN DRILLDOWN ****************************


    // ****************** END DRILLDOWN ****************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchdataPointExpressions => [

        {    field: 'id',
            headerName: 'ID',
            sortable: true,
            width: 80,
        },
        {    field: 'dataSet',
            headerName: 'Data Set',
            sortable: true,
            width: 100,
        },
        {    field: 'contractType',
            headerName: 'Type',
            sortable: true,
            width: 130,
        },
        {    field: 'contractCategory',
            headerName: 'Category',
            sortable: true,
            width: 250,
        },
        {    field: 'contractName',
            headerName: 'Contract',
            sortable: true,
            width: 300,
        },
        {    field: 'sectionName',
            headerName: 'Section',
            sortable: true,
            width:500,
        },
        {    field: 'sectionOrdinalNumber',
            headerName: 'Order',
            sortable: true,
            width: 80,
        },
        // {    field: 'dataPointName',
        //     headerName: 'Data Point',
        //     sortable: true,
        //     width: 200,
        // },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            sortable: true,
            width: 200,
            renderCell: (params) => (
                <Tooltip title={params.value} enterDelay={2000}  enterNextDelay={2000}>
                    <span>{params.value}</span>
                </Tooltip>
            ),
        },
        {
            field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
            // type: 'actions',  // Required for built-in expand behavior
            headerName: '',
            renderCell: (fetchDataPointExpressionList) =>
            {
                if((fetchDataPointExpressionList.row.mockExpression !== null) && (fetchDataPointExpressionList.row.mockExpression !== '')){

                    return (
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"Value comes from an expression.  Click to see."}>
                            <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                        </Tooltip>)}
            },
            description: '',
            sortable: false,
            width: 50,
        }
    ];

    // ****************** END COLUMNS ****************************

    const getDetailPanelHeight = React.useCallback(() => 300, []);

    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1700 },
                }}
                anchor='right'
                // open={true}
                open={selectorExpressionDrawerState}
                initialState={{open: false}}
                onClose={closeExpressionListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeExpressionListDrawer()}>Contract Data Point Value Expressions</h1>
                    {/*<h4>id: {displayId} name: {displayName}</h4>*/}
                    <Stack direction="row" spacing={1}>
                        <Typography component="span">id:</Typography>
                        <Typography component="span" fontWeight="bold">{displayId}</Typography>
                        <Box sx={{ ml: 6 }} /> {/* Adds extra spacing before 'name:' */}
                        <Typography component="span">name:</Typography>
                        <Typography component="span" fontWeight="bold">{displayName}</Typography>
                    </Stack>
                </Box>
                <DataGridPro
                    sx={{
                        '& .MuiDataGrid-detailPanel': {
                            backgroundColor: deepOrange[100],
                        },
                        // '& .level--1': { backgroundColor: "rgb(30,144,255)" },
                        // ... // your other styles
                    }}
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"dataPointExpressions"}
                    rows={dataPointExpressions}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(fetchDataPointExpressionList)}
                    density={"compact"}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    rowKey={dataPointExpression => dataPointExpression.id}
                    getDetailPanelContent={({ row }) => (
                        <Box sx={{ p: 2,
                            bgcolor: deepOrange[100]
                            // backgroundColor: "rgb(255,204,153)"
                        }}>
                            <Box sx={{ml: 2}}>
                                <strong>Expression:</strong> {row.expression}
                            </Box>
                            <br/>
                            <Box sx={{ml: 2}}>
                                <strong>Translation:</strong> {row.expressionTranslation}
                            </Box>
                            <br/>
                        </Box>
                    )}
                    getDetailPanelHeight={getDetailPanelHeight}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
